jQuery(function() {
  initFormValidation(); // Look into custom/init-form-validation.js . Also, reference custom/set-referrers.js
});